import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { useCallback } from 'react';

import { useToggleMenu } from '../../../hooks';
import { BurgerMenuIcon } from '../BurgerMenuIcon';
import { BURGER_MENU_TOGGLE_ROOT } from '../constants';
import { BurgerMenuToggleRoot, StyledPbsTooltip } from './styles';

export const BurgerMenuToggle: FC = () => {
  const [, toggleMenu] = useToggleMenu();
  const { getTestId } = useTestId();

  // istanbul ignore next -- already tested in the PbsTooltip component
  const onPbsTooltipClick = useCallback(() => {
    toggleMenu();
  }, [toggleMenu]);

  return (
    <BurgerMenuToggleRoot data-testid={getTestId(BURGER_MENU_TOGGLE_ROOT)}>
      <BurgerMenuIcon />
      <StyledPbsTooltip onClick={onPbsTooltipClick} />
    </BurgerMenuToggleRoot>
  );
};
